module.exports = __webpack_public_path__ + "static/media/office-view.02088954.svg";